import React from 'react';
import { Link as GLink } from 'gatsby';

import { LogoLink as AchievableLogoLink } from '@achievable-me/ux';

const LogoLink = ({ className }) => (
  <AchievableLogoLink className={className} CustomLink={GLink} to="/" />
);

export default LogoLink;
